(($)=>{

	if(
		document.body.classList.contains('page-template-template-iframe-purple') ||
		document.body.classList.contains('page-template-template-iframe')
	){
		return; // do nothing as we are inside iframe.
	}

	// do postMessage processing here.
	window.addEventListener('message', function receiveMessage(event) {
		// Do we trust the sender of this message?
		// if (event.origin !== "https://miniluxe.com" && event.origin !== "https://shop.miniluxe.com"){
			// console.warn('Some iframe tried to pass in un allowed message from origin ',event.origin ,event);
			// return;
		// }

		// console.log('all is good, trying to trigger event', event);

		if( event.data.eventName === 'gravityFormSubmission' && event.data.formId ){

			// console.log('Triggering gforms submitted event on current document for GTM', event);
			jQuery(document).trigger('gform_confirmation_loaded', [event.data.formId] );

		}
	});

})(jQuery);